var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2918 3.19877C11.2123 3.23038 11.1372 3.27173 11.0679 3.32188C10.5606 3.7919 10.0589 4.26938 9.55342 4.74314L4.4615 9.52358L0 7.8785L13.9888 0C13.2595 4.10338 12.5377 8.14522 11.8103 12.2318C10.7415 11.8588 9.69891 11.4484 8.6227 11.0679L6.11404 14C6.11404 13.0338 6.11404 12.1348 6.11404 11.2377C6.11404 10.8646 6.1271 10.4916 6.13269 10.1335C6.34532 9.84439 6.55422 9.55529 6.76685 9.26805C8.25899 7.27853 9.74678 5.28155 11.2302 3.27711C11.2489 3.251 11.2638 3.21929 11.2824 3.19131L11.2955 3.17826C11.2974 3.15961 11.2955 3.18199 11.2918 3.19877Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlack);
export default __webpack_public_path__ + "static/media/telegram-black.1c2ee87f56f89d120d031e88371b3309.svg";
export { ForwardRef as ReactComponent };